/* eslint-disable jsx-a11y/anchor-is-valid */
import { Routes, Route, useLocation  } from 'react-router-dom';
import React, { useEffect } from 'react';
import Header from './components/Header.tsx';
import Hero from './components/Hero.tsx';
import Footer from './components/Footer.tsx';
import About from './components/About.tsx';
import Services from './components/Services.tsx';
import Products from './components/Products.tsx';
import Ads from './components/Ads.tsx';
import Contact from './components/Contact.tsx';
import ProductDetail from './components/ProductDetail.tsx';
import { database } from './data/database.ts';

import AOS from 'aos';
import 'aos/dist/aos.css';

const App: React.FC = () => {

  const location = useLocation();
  const db = database;

  useEffect(() => {
    AOS.init({
      duration: 600,
      easing: 'ease-in-out',
      once: true,
      mirror: false
    });
  }, []);

  useEffect(() => {
    if (location.pathname === '/') {
      const timeoutId = setTimeout(() => {
        const script = document.createElement('script');
        script.src = '/assets/js/main.js';
        script.async = true;
        document.body.appendChild(script);

        return () => {
          document.body.removeChild(script);
        };
      }, 1000);

      return () => clearTimeout(timeoutId);
    }
  }, [location.pathname]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const preloader = document.querySelector('#preloader');
      if (preloader) {
        preloader.remove();
      }
    }, 1000);
    return () => clearTimeout(timeoutId);
  }, []);


  return (
    <>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <About />
              <Services />
              <Products />
              <Ads />
              <Contact />
            </>
          } />
          <Route path="/productos/:id" element={
            <>
              <ProductDetail />
              <Contact />
            </>
          } />
        </Routes>
      </main>
      <Footer />
      <a href="#" id="scroll-top" className="scroll-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short"></i></a>
      <a href={db.walink} id="whatsapp-button" className="whatsapp-button d-flex align-items-center justify-content-center"><i class="bi bi-whatsapp"></i></a>
      <div id="preloader"></div>
    </>
  );
};

export default App;
